import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#ca0a37'
      }
    },
    options: {
      customProperties: true
    }
  }
})
